import React from 'react';
import Step from '../../../components/wizard/Step';
import StepFooter from '../../../components/wizard/StepFooter';
import routes from '../../../routes/constants';
import text from '../../../text';
import MembershipForm from '../Membership/MembershipForm';
var MembershipStep = function(param) {
    var membershipPriceId = param.membershipPriceId, onMembershipChange = param.onMembershipChange, includeNoMembership = param.includeNoMembership, nextButtonProps = param.nextButtonProps, previousButtonProps = param.previousButtonProps;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Step, {
        className: "MembershipStep",
        title: text('selectMembership'),
        extraText: /*#__PURE__*/ React.createElement("div", null, text('membershipFeaturesSummary'), /*#__PURE__*/ React.createElement("div", {
            className: "mt-3"
        }, /*#__PURE__*/ React.createElement("a", {
            target: "_blank",
            rel: "noreferrer",
            href: routes.larkiWebsiteUrl.memberships
        }, text('learnMore'))))
    }, /*#__PURE__*/ React.createElement(Step.Content, null, /*#__PURE__*/ React.createElement(MembershipForm, {
        includeNoMembership: includeNoMembership,
        membershipPriceId: membershipPriceId,
        onMembershipChange: onMembershipChange
    }))), /*#__PURE__*/ React.createElement(StepFooter, {
        previousButtonProps: previousButtonProps,
        nextButtonProps: nextButtonProps
    }));
};
export default MembershipStep;
